// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1TdsI","fileBtn":"File_fileBtn__V0dar","closeBtn":"File_closeBtn__3kFPX","fileSelected":"File_fileSelected__O8yst","disabled":"File_disabled__3arS-"};